import { Permission } from 'api/planning';
import { RouteDefinition } from './types';
import { OrganisationStructureLevel } from 'const';

type Routes =
  | 'lrwSessions'
  | 'createLrwSession'
  | 'lrwSessionDetails'
  | 'linkSpeakingSession'
  | 'addRoomToLrwSession'
  | 'releaseLrwSession'
  | 'releaseLrwWithSpeakingSessions'
  | 'editLrwSession'
  | 'removeLrwSession'
  | 'removeLrwSessionRoom';

export const getLrwRoutes: (basePath: string) => Record<Routes, RouteDefinition> = (basePath) => ({
  lrwSessions: {
    path: '',
    absolutePath: basePath,
    requiresAny: [Permission.ViewPlanningSession],
    filters: [{ required: OrganisationStructureLevel.Location }],
  },
  createLrwSession: {
    path: 'create',
    absolutePath: `${basePath}/create`,
    requiresAny: [Permission.ManagePlanningSession],
    filters: [{ required: OrganisationStructureLevel.Location }],
  },
  lrwSessionDetails: {
    path: ':sessionId',
    absolutePath: `${basePath}/:sessionId`,
    requiresAny: [Permission.ViewPlanningSession],
    filters: [{ required: OrganisationStructureLevel.Location }],
  },
  linkSpeakingSession: {
    path: 'link-speaking-session',
    absolutePath: `${basePath}/:sessionId/link-speaking-session`,
    requiresAny: [Permission.ManagePlanningSession],
    filters: [{ required: OrganisationStructureLevel.Location }],
  },
  addRoomToLrwSession: {
    path: 'add-room',
    absolutePath: `${basePath}/:sessionId/add-room`,
    requiresAny: [Permission.ManagePlanningSession],
    filters: [{ required: OrganisationStructureLevel.Location }],
  },
  releaseLrwSession: {
    path: 'release',
    absolutePath: `${basePath}/:sessionId/release`,
    requiresAny: [Permission.ManagePlanningSession],
    filters: [{ required: OrganisationStructureLevel.Location }],
  },
  releaseLrwWithSpeakingSessions: {
    path: 'release-with-speaking',
    absolutePath: `${basePath}/:sessionId/release-with-speaking`,
    requiresAny: [Permission.ManagePlanningSession],
    filters: [{ required: OrganisationStructureLevel.Location }],
  },
  editLrwSession: {
    path: 'edit',
    absolutePath: `${basePath}/:sessionId/edit`,
    requiresAny: [Permission.ManagePlanningSession],
    filters: [{ required: OrganisationStructureLevel.Location }],
  },
  removeLrwSession: {
    path: 'remove',
    absolutePath: `${basePath}/:sessionId/remove`,
    requiresAny: [Permission.ManagePlanningSession],
    filters: [{ required: OrganisationStructureLevel.Location }],
  },
  removeLrwSessionRoom: {
    path: 'rooms/:sessionRoomId/remove',
    absolutePath: `${basePath}/:sessionId/rooms/:sessionRoomId/remove`,
    requiresAny: [Permission.ManagePlanningSession],
    filters: [{ required: OrganisationStructureLevel.Location }],
  },
});
